var map = {
	"./toast_error.svg": "07VB",
	"./toast_success.svg": "pyJh",
	"./warn.svg": "x2VQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dx2V";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/toast nonrecursive \.svg$
// module id = dx2V
// module chunks = 55